import { render, staticRenderFns } from "./user-edit-modal.vue?vue&type=template&id=2b3366e6&scoped=true&"
import script from "./user-edit-modal.vue?vue&type=script&lang=js&"
export * from "./user-edit-modal.vue?vue&type=script&lang=js&"
import style0 from "./user-edit-modal.vue?vue&type=style&index=0&id=2b3366e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3366e6",
  null
  
)

export default component.exports